export const types = {
  SUBMIT_STRIPE_UPDATE_REQUEST:
    'Settings/Accounting/Settings/BankingInformationModal/BankingInfoOnlyData/SUBMIT_STRIPE_UPDATE_REQUEST',
  SUBMIT_STRIPE_UPDATE_SUCCESS:
    'Settings/Accounting/Settings/BankingInformationModal/BankingInfoOnlyData/SUBMIT_STRIPE_UPDATE_SUCCESS',
  SUBMIT_STRIPE_UPDATE_ERROR:
    'Settings/Accounting/Settings/BankingInformationModal/BankingInfoOnlyData/SUBMIT_STRIPE_UPDATE_ERROR',
};

export const submitStripeUpdate = {
  request: ({ token, onSuccess, onError }) => ({
    type: types.SUBMIT_STRIPE_UPDATE_REQUEST,
    payload: { token, onSuccess, onError },
  }),
  success: ({ onSuccess }) => ({
    type: types.SUBMIT_STRIPE_UPDATE_SUCCESS,
    payload: { onSuccess },
  }),
  error: ({ onError }) => ({
    type: types.SUBMIT_STRIPE_UPDATE_ERROR,
    payload: { onError },
  }),
};
